

// profileOptions.js

export const bestArray = [
    { id: "1", code: "BEST_HAIR", detail: "Hair" },
    { id: "2", code: "BEST_ARMS", detail: "Arms" },
    { id: "3", code: "BEST_BUTT", detail: "Butt" },
    { id: "4", code: "BEST_EYES", detail: "Eyes" },
    { id: "5", code: "BEST_LEGS", detail: "Legs" },
    { id: "6", code: "BEST_LIPS", detail: "Lips" },
    { id: "7", code: "BEST_BREAST", detail: "Breasts" },
    { id: "8", code: "BEST_BELLY", detail: "Abs" },
    { id: "9", code: "BEST_BACK", detail: "Back" },
    { id: "10", code: "BEST_FEET", detail: "Feet" },
    { id: "11", code: "BEST_PENIS", detail: "Mr Happy" },
    { id: "12", code: "BEST_THIGHS", detail: "Thighs" },
    { id: "13", code: "BEST_SMILE", detail: "Smile" },
  ];

  
  
  export const eyeArray = [
    {id: "1", code: "EYE_BLACK", detail: "Black"},
    {id: "2", code: "EYE_BLUE", detail: "Blue"},
    {id: "3", code: "EYE_BROWN", detail: "Brown"},
    {id: "4", code: "EYE_GREY", detail: "Grey"},
    {id: "5", code: "EYE_GREEN", detail: "Green"},
    {id: "6", code: "EYE_HAZEL", detail: "Hazel"}
  ];


  export const educationArray= [
    {id: "1", code: "EDU_HIGH", detail: "High School"},
    {id: "2", code: "EDU_SOMECOLLEGE", detail: "Some College"},
    {id: "3", code: "EDU_ASSOC", detail: "Associates Degree"},
    {id: "4", code: "EDU_BACHELORS", detail: "Bachelors Degree"},
    {id: "5", code: "EDU_GRAD", detail: "Graduate Degree"},
    {id: "6", code: "EDU_PHD", detail: "PhD/Post Doctoral"}
  ];


  export const ethnicityArray = [
    {id: "1", code: "ETH_ASIAN", detail: "Asian"},
    {id: "2", code: "ETH_BLACK", detail: "African American(black)"},
    {id: "3", code: "ETH_EAST_INDIAN", detail: "East Indian"},
    {id: "4", code: "ETH_LATINO_HISPANIC", detail: "Latino/Hispanic"},
    {id: "5", code: "ETH_MIDDLE_EASTERN", detail: "Middle Eastern"},
    {id: "6", code: "ETH_NATIVE_AMERICAN", detail: "Native American"},
    {id: "7", code: "ETH_PACIFIC_ISLANDER", detail: "Pacific Islander"},
    {id: "8", code: "ETH_WHITE_CAUCASIAN", detail: "Caucasian(white)"},
    {id: "9", code: "ETH_INTER_RACIAL", detail: "Inter-Racial"},
    {id: "10", code: "ETH_OTHER", detail: "Other"}
  ];


  export const bodyArray = [
    {id: "1", code: "BODY_SLENDER", detail: "Slender"},
    {id: "2", code: "BODY_ATHLETIC", detail: "Athletic"},
    {id: "3", code: "BODY_FIT", detail: "Fit"},
    {id: "4", code: "BODY_AVERAGE", detail: "Average"},
    {id: "5", code: "BODY_EXTRA", detail: "Extra"},
    {id: "6", code: "BODY_THICK", detail: "Thick"},
    {id: "7", code: "BODY_LARGE", detail: "Large"},
    {id: "8", code: "BODY_VOLUPTUOUS", detail: "Voluptuous"}
  ];

  export const politalArray = [
    {id: "1", code: "POL_VERYCONSER", detail: "Very Conservative"},
    {id: "2", code: "POL_CONSERVATIVE", detail: "Conservative"},
    {id: "3", code: "POL_MIDDLEROAD", detail: "Middle of the road"},
    {id: "4", code: "POL_LIBERAL", detail: "Liberal"},
    {id: "5", code: "POL_VERYLIBERAL", detail: "Very liberal"},
    {id: "6", code: "POL_NOTPOLITICAL", detail: "Not political"}
  ];
